<div class="mat-select-arrow-wrapper">
  <div class="mat-select-arrow"></div>
</div>
<!-- This only exists so that Angular includes the mat-select styles when this module is built -->
<mat-select class="mc-hidden"></mat-select>